import { render, staticRenderFns } from "./UiMarketShowcase.vue?vue&type=template&id=2b1704c2&"
import script from "./UiMarketShowcase.vue?vue&type=script&lang=js&"
export * from "./UiMarketShowcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports